import React, { FC, ReactNode } from 'react';
import './CloseButton.css';
import { ActionButton } from '..';
import { IoClose } from '@/Shared/Lib';

interface CloseButtonProps {
	onClick: () => void;
	label?: string;
	icon? : ReactNode;
	showLabel? : boolean;
	tooltip? : string;
	disabled? : boolean;
	classNames? : string
}

const CloseButton: FC<CloseButtonProps> = ({ 
	onClick, 
	label = "Fermer", 
	tooltip = "Bouton fermeture", 
	icon = <IoClose />, 
	disabled,
	classNames = "",
	showLabel=false 
}) => (
	<ActionButton
	    classNames = {"CloseButton " + classNames}
		icon={icon}
		label={label}
		onClick={onClick}
		showLabel={showLabel}
		tooltip={tooltip}
		disabled={disabled}
	/>
);

export default CloseButton;